import ContentComponent from './content.component'

const ContentModule = angular.module('cdbl.layout.content', [

])
  .component('cdblContent', ContentComponent)
  .name

export default ContentModule
